import tippy from 'tippy.js';

// Renderer for the "{{" merge-tag autocomplete. Builds a Tippy popup listing the
// matching variables grouped by their dictionary title. Returns the lifecycle
// object expected by @tiptap/suggestion (onStart/onUpdate/onKeyDown/onExit).
export function createMergeTagDropdown() {
  let popup;
  let menuElement;
  let items = [];
  let selectedIndex = 0;
  let runCommand;

  function renderList() {
    menuElement.innerHTML = '';

    if (items.length === 0) {
      const emptyState = document.createElement('div');
      emptyState.className = 'merge-tag-menu__empty';
      emptyState.textContent = 'Nenhuma variável encontrada';
      menuElement.appendChild(emptyState);
      return;
    }

    let lastGroupTitle = null;
    items.forEach((item, index) => {
      if (item.group && item.group !== lastGroupTitle) {
        const groupHeader = document.createElement('div');
        groupHeader.className = 'merge-tag-menu__group';
        groupHeader.textContent = item.group;
        menuElement.appendChild(groupHeader);
        lastGroupTitle = item.group;
      }

      const itemButton = document.createElement('button');
      itemButton.type = 'button';
      itemButton.className = `merge-tag-menu__item${index === selectedIndex ? ' is-selected' : ''}`;
      itemButton.innerHTML =
        `<span class="merge-tag-menu__title"></span><span class="merge-tag-menu__code"></span>`;
      itemButton.querySelector('.merge-tag-menu__title').textContent = item.title;
      itemButton.querySelector('.merge-tag-menu__code').textContent = `{{${item.value}}}`;
      itemButton.addEventListener('mousedown', (event) => {
        event.preventDefault();
        runCommand(item);
      });
      menuElement.appendChild(itemButton);
    });
  }

  function selectCurrent() {
    const item = items[selectedIndex];
    if (item) runCommand(item);
  }

  return {
    onStart(props) {
      items = props.items;
      runCommand = props.command;
      selectedIndex = 0;
      menuElement = document.createElement('div');
      menuElement.className = 'merge-tag-menu';
      renderList();

      popup = tippy(document.body, {
        getReferenceClientRect: props.clientRect,
        appendTo: () => document.body,
        content: menuElement,
        showOnCreate: true,
        interactive: true,
        trigger: 'manual',
        // Anchor the menu's right edge to the caret so it grows LEFT (and down),
        // and restrict flipping to the vertical axis only — it must never open to
        // the right. `strategy: 'fixed'` positions it relative to the viewport so it
        // can't widen the document (the absolute-on-body overflow was what broke the
        // layout with a horizontal scrollbar).
        placement: 'bottom-end',
        popperOptions: {
          strategy: 'fixed',
          modifiers: [
            { name: 'flip', options: { fallbackPlacements: ['top-end'] } },
            { name: 'preventOverflow', options: { boundary: 'viewport', altAxis: true, padding: 8 } }
          ]
        },
        theme: 'light'
      });
    },

    onUpdate(props) {
      items = props.items;
      runCommand = props.command;
      selectedIndex = 0;
      renderList();
      if (props.clientRect) popup.setProps({ getReferenceClientRect: props.clientRect });
    },

    onKeyDown(props) {
      if (props.event.key === 'Escape') {
        popup.hide();
        return true;
      }
      if (items.length === 0) return false;

      if (props.event.key === 'ArrowDown') {
        selectedIndex = (selectedIndex + 1) % items.length;
        renderList();
        return true;
      }
      if (props.event.key === 'ArrowUp') {
        selectedIndex = (selectedIndex + items.length - 1) % items.length;
        renderList();
        return true;
      }
      if (props.event.key === 'Enter') {
        selectCurrent();
        return true;
      }
      return false;
    },

    onExit() {
      if (popup) popup.destroy();
    }
  };
}
